// import React from "react";
// import { Box, Typography } from "@mui/material";

// const SustainableImage = ({ imageSrc }) => {
//   return (
//     <Box
//       sx={{
//         display: "flex",
//                 justifyContent: "center",
//                 width: "350px",
//                 height: "350px",
//                 alignItems: "center",
//                 overflow: "hidden",
//                 borderRadius: "8px",
//       }}
//     >
//       <Box
//         sx={{
//           position: "relative",
//           display: "grid",
//           gridTemplateColumns: "repeat(3, 1fr)",
//           gridTemplateRows: "repeat(3, 1fr)",
//           borderRadius: "8px",
//           padding: "16px",
//           transition: "transform 0.7s ease-in-out",
//           transformOrigin: "top right",
//           transform: "scale(1.1)",
//           "&:hover": {
//             transform: "scale(1.05)",
//           },
//         }}
//       >
//         {/* Background Grid Lines */}
//         {Array.from({ length: 2 }).map((_, row) => (
//           <Box
//             key={`row-${row}`}
//             sx={{
//               position: "absolute",
//               top: `${(row + 1) * 50}%`,
//               left: 0,
//               width: "100%",
//               height: "2px",
//               backgroundColor: "#33BFFF",
//             }}
//           />
//         ))}
//         {Array.from({ length: 2 }).map((_, col) => (
//           <Box
//             key={`col-${col}`}
//             sx={{
//               position: "absolute",
//               left: `${(col + 1) * 50}%`,
//               top: 0,
//               width: "2px",
//               height: "100%",
//               backgroundColor: "#33BFFF",
//             }}
//           />
//         ))}

//         {/* Image in First Row Last Column */}
//         <Box
//           sx={{
//             gridColumn: "3 / 4",
//             gridRow: "1 / 2",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <Box
//             component="img"
//             src={imageSrc}
//             alt="Sustainable Business"
//             sx={{
//               maxWidth: "100%",
//               maxHeight: "100%",
//               objectFit: "contain",
//               borderRadius: "8px",
//             }}
//           />
//         </Box>

//         {/* Text in Last Row Last Column */}
//         <Box
//           sx={{
//             gridColumn: "3 / 4",
//             gridRow: "3 / 4",
//             display: "flex",
//             alignItems: "flex-end",
//             justifyContent: "flex-end",
//             padding: "8px",
//             width: "100%",
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{
//               color: "#33BFFF",
//               textAlign: "right",
//               width: "100%",
//               fontWeight: "bold",
//             }}
//           >
//             Sustainable
//           </Typography>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default SustainableImage;



import React from "react";
import { Box, Typography } from "@mui/material";

const SustainableImage = ({ data }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "350px",
        height: "350px",
        alignItems: "center",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <Box
        sx={{
          position: "relative",
          background: "#04133a",
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gridTemplateRows: "repeat(3, 1fr)",
          borderRadius: "8px",
          padding: "16px",
          border: "2px solid #33BFFF",
          transition: "transform 0.7s ease-in-out",
          transform: `scale(3.4)`,
          "&:hover": {
            transform: "scale(2)",
          },
           "&:hover .subtitleOverlay": {
              opacity: 1,
            },

            "&:hover img": {
              opacity: 1,
            },
        }}
      >
        {/* Background Grid Lines */}
        {Array.from({ length: 4 }).map((_, i) => (
          <Box
            key={`h-${i}`}
            sx={{
              position: "absolute",
              top: `${i * 33.3}%`,
              left: 0,
              width: "100%",
              height: "2px",
              backgroundColor: "#33BFFF",
            }}
          />
        ))}

        {Array.from({ length: 4 }).map((_, i) => (
          <Box
            key={`v-${i}`}
            sx={{
              position: "absolute",
              left: `${i * 33.3}%`,
              top: 0,
              width: "2px",
              height: "100%",
              backgroundColor: "#33BFFF",
            }}
          />
        ))}

        {/* TOP TITLE */}
        <Box
          sx={{
            gridColumn: "2 / 3",
            gridRow: "1 / 2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 3,
          }}
        >
          <Typography
            sx={{
              color: "#ffffff",
              fontSize: "8px",
              fontWeight: 600,
              textAlign: "center",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            {data?.title}
          </Typography>
        </Box>

        {/* CENTER IMAGE */}
        <Box
          sx={{
            gridColumn: "2 / 3",
            gridRow: "2 / 3",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

           
          }}
        >
          <Box
            component="img"
            src={data?.imageSrc}
            alt={data?.title}
            sx={{
              width: "100%",
              height: "100%",
              borderRadius: "8px",
              zIndex: 1,
              transition: "all 0.4s ease",
            }}
          />

          {/* SUBTITLE OVERLAY */}
          <Box
            className="subtitleOverlay"
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              p: 1,
              opacity: 0,
              transition: "all 0.4s ease",
              background: "rgba(4, 19, 58, 0.6)",
              borderRadius: "8px",
              zIndex: 2,
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: "8px",
                fontWeight: 500,
                lineHeight: 1.4,
              }}
            >
              {data?.subTitle}
            </Typography>
          </Box>
        </Box>

        {/* BOTTOM TITLE */}
        <Box
          sx={{
            gridColumn: "2 / 3",
            gridRow: "3 / 4",
            display: "flex",
            mt: "12px",
            alignItems: "flex-start",
            justifyContent: "center",
            zIndex: 3,
          }}
        >
          <Typography
            sx={{
              color: "#00b4d8",
              fontSize: "8px",
              fontWeight: 600,
            }}
          >
            {data?.title}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SustainableImage;